module.exports = __webpack_public_path__ + "img/Menu-09.59152468.png";